<template>
  <div class="mb-2">
    <div
      class="row pt-0"
      :class="[
        styleCard === 'multiple'
          ? 'card-serv card-serv-h'
          : 'card-serv card-serv-h no-select',
        selected ? 'card-active' : '',
        service.blackout ? 'ribbon-card' : ''
      ]"
      @click="selectService"
    >
      <span class="ribbon danger" v-if="service.blackout">BlackOut</span>
      <div class="col-12 top-service text-center">
        <span>
          <strong>Destination: </strong>
          {{ getBranchName(service.branchId) }}
        </span>
      </div>

      <div class="col-xl-2 col-md-2 col-sm-2 col-12 align-self-center alinmov1">
        <img
          v-lazy="service.vehicle.image"
          class="img-service"
          alt="Service Car"
        />
      </div>

      <div class="col-sm-10 col-12 px-xl-0 px-lg-0 px-md-0 pr-sm-0">
        <div class="row">
          <div
            class="col-xl-5 col-lg-5 col-md-4 col-sm-7 col-12 align-self-center alinmov1 pl-sm-0"
          >
            <h2 class="title-serv">
              {{ formatServiceCategory(service.vehicle.category) }}
              {{ service.vehicle.seats }} seats
            </h2>

            <span class="type-card">{{ getInternalName(service) }}</span>

            <div class="descrip">
              <span>
                <i class="flaticon-web-friends"></i>
                {{ service.vehicle.seats }}
              </span>

              <span>
                <i class="flaticon-web-suitcase"></i>
                {{ service.vehicle.suitcases }}
              </span>
            </div>

            <!-- tags block -->
            <div
              class="d-block mb-1"
              v-if="service.vehicle.tags && service.vehicle.tags.length"
            >
              <span
                class="badge-tag"
                v-for="tag in service.vehicle.tags"
                :key="tag.ref"
              >
                {{ tag.name }}
              </span>
            </div>
            <!-- end tag block -->

            <div class="d-xl-block d-lg-block d-md-block d-sm-none d-none">
              <div class="collapse-services" v-b-toggle="service._id">
                <span>Key Details, Cancellations & Terms</span
                ><i class="when-open flaticon-up-1"></i
                ><i class="when-closed flaticon-down-1"></i>
              </div>
            </div>
          </div>

          <div
            class="col-xl-3 col-lg-3 col-md-4 col-sm-5 col-12 bottom-details align-self-center"
          >
            <div class="details-services">
              <ul>
                <li v-if="service.preference.wifi">
                  <i class="flaticon-web-wifi"></i>
                  WiFi onboard
                </li>
                <li v-if="service.preference.water">
                  <i class="flaticon-web-water"></i>
                  Water
                </li>
                <li v-if="service.preference.hand_sanitizer">
                  <i class="flaticon-web-sanitizer"></i>
                  Hand Sanitizer
                </li>
              </ul>
            </div>
          </div>

          <div
            class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 bottom-price align-self-center"
          >
            <span class="price">
              {{ service.currency.symbol }}
              {{
                calculateTotalNetPrice(service.base_price, service.surcharges)
              }}
              {{ service.currency.code }}
            </span>
            <span
              class="f-12 lh-100 d-block mb-0"
              v-if="['hourly', 'HOURLY'].includes(transferType)"
            >
              {{ getDistanceInclude(service, hourly) }}
              {{ getUnitFormat(service.unit) }}. included
            </span>
            <span class="f-12 lh-100 d-block mb-0" v-else>
              One-Way
            </span>
          </div>

          <div
            class="col-12 d-xl-none d-lg-none d-md-none d-sm-block d-block p-0 "
          >
            <div class="collapse-services" v-b-toggle="service._id">
              <span>Instructions, Cancellations & Terms</span
              ><i class="when-open flaticon-up-1"></i
              ><i class="when-closed flaticon-down-1"></i>
            </div>
          </div>

          <b-collapse :id="service._id" class="cancellations">
            <div class="col-12 " v-if="service.keyDetails">
              <div class="data-block mb-2 mt-2">
                <span class="title-block f-14">Key Details</span>
                <span class="content-block">
                  {{ service.keyDetails }}
                </span>
              </div>
            </div>

            <div class="col-12" :class="service.keyDetails ? 'border-top' : ''">
              <div class="data-block mb-1 mt-2">
                <span class="title-block f-14">Cancellations Policies</span>
              </div>

              <ul class="mb-3 pl-4">
                <li
                  v-for="(item, index) in service.cancellationPolicy"
                  :key="`${index}`"
                >
                  {{ item }}
                </li>
              </ul>
            </div>

            <div class="col-12 border-top" v-if="service.termsConditions">
              <div class="data-block mb-2 mt-2">
                <span class="title-block f-14">Terms and Conditions</span>
                <span class="content-block">
                  {{ service.termsConditions }}
                </span>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calculateTotalPrice } from "../services/price.service";
export default {
  name: "Services",
  props: {
    service: {
      type: Object,
      required: true,
      description: ""
    },
    selected: {
      type: Boolean,
      required: true,
      description: ""
    },
    branches: {
      type: Array,
      required: true,
      description: ""
    },
    styleCard: {
      type: String,
      default: "multiple",
      description: "(multiple, single)"
    },
    transferType: {
      type: String,
      required: true
    },
    hourly: {
      type: Number,
      default: 0
    }
  },
  methods: {
    /**
     * Format category type
     * @param {*} type type of category
     * @returns {string} formatted category type
     */
    formatServiceCategory(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    /**
     * Get branch name by id
     * @param {string} branchId id of the branch
     * @returns {string} name of the branch
     */
    getBranchName(branchId) {
      let branch = this.branches.find(branch => branch._id === branchId);
      if (branch) {
        return branch.name;
      }
      return "Destination Name";
    },
    /**
     * Calculate total net price with surcharges
     * @param {number} netPrice base net price
     * @param {Array} surcharges list of surcharges
     * @returns {string} total net price formatted to 2 decimal places
     */
    calculateTotalNetPrice(netPrice, surcharges = []) {
      let total = calculateTotalPrice(parseFloat(netPrice), surcharges, "net");
      return total.toFixed(2);
    },
    /**
     * Emit select service event
     */
    selectService() {
      this.$emit("selectService", this.service);
    },
    /**
     * Get internal name of the service vehicle
     * @param {Object} service service object
     * @returns {string} internal name of the vehicle
     */
    getInternalName(service) {
      try {
        let vehicleName = new String(service.vehicle.make_label);
        if (!service.vehicle.isComposite) {
          return `${vehicleName} or Similar`;
        } else {
          if (vehicleName.includes("+")) {
            let [leftPart, rightPart] = vehicleName.split("+");
            return `${leftPart} or Similar + ${rightPart}`;
          } else {
            return vehicleName;
          }
        }
      } catch (error) {
        return `${service.vehicle.make_label} or Similar`;
      }
    },
    /**
     * Get formatted unit string
     * @param {string} unit unit type
     * @returns {string} formatted unit
     */
    getUnitFormat(unit) {
      if (unit === "miles") {
        return "Miles";
      } else {
        return "Km";
      }
    },
    /**
     * Calculate distance included based on hourly rate
     * @param {Object} service service object
     * @param {number} hourly number of hours
     * @returns {number} distance included
     */
    getDistanceInclude(service, hourly = 1) {
      if (hourly > service.min_hours) {
        return hourly * service.distance_include;
      } else {
        return service.distance_include * service.min_hours;
      }
    }
  }
};
</script>
